import { IDonor } from '@nkr/models/donor';
import React, { MouseEvent as ReactMouseEvent } from 'react';
import { TopButtonsWrapper } from './styles';
import { usePDF } from '@react-pdf/renderer';
import DonorInfo from './donor-info';
import { FinancialAgreement } from './documents/financial-agreement';

interface IProps {
    isRecipientCenter: boolean,
    donorId: number,
    recipientId: number,
    centerIdToPrint: number,
    otherCenterId: number,
    centerIdForContacts: number,
    reportDonorId: number,
    reportRecipientId: number,
    centerId: number,
    donor: IDonor,
    onShowHideSerologyTests: () => void,
    onDownloadFormsAndChecklists: (donorId: number, recipientId: number) => void
}

const TopButtons = (props: IProps) => {
    const [instance, updateInstance] = usePDF({ document: <DonorInfo data={props.donor} debug={false} /> });

    const handleShowHideSerologyTests = (e: ReactMouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();

        props.onShowHideSerologyTests();
    };

    const handleGetFormsChecklists = (e: ReactMouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();

        props.onDownloadFormsAndChecklists(props.reportDonorId, props.reportRecipientId);
    };

    const handleMatchOffer = (e: ReactMouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();

        window.print();
    };

    return (
        <TopButtonsWrapper className='container no-print'>
            <div className='row'>
                <div className='col-xs-12'>
                    <div className='bg-info' style={{ display: 'flex', justifyContent: 'center', borderRadius: 4 }}>
                        <a className='btn btn-link' href='https://www.kidneyregistry.com/GPSTracking' target='Document'>GPS INSTRUCTIONS</a>
                        <a className='btn btn-link' href={'/logistics/position/' + props.donorId + '/' + props.recipientId} target='_blank'>LOGISTICS PLAN</a>

                        {props.isRecipientCenter && (
                            <a className='btn btn-link' onClick={handleMatchOffer}>MATCH OFFER</a>
                        )}

                        <a className='btn btn-link' href={`/center/${props.centerId}/reports/all-centers/details/${props.centerIdForContacts}`} target='_blank'>CENTER CONTACTS</a>
                        <a className='btn btn-link' href={instance.url} download={'donor-info-' + props.donor.alias + '.pdf'}>DONOR INFO</a>
                        <FinancialAgreement className='btn btn-link' centerId={props.centerId} donorId={props.donorId} recipientId={props.recipientId}><span className='text'>FINANCIAL INFO</span></FinancialAgreement>
                        <a className='btn btn-link' onClick={handleGetFormsChecklists}>FORMS &amp; CHECKLISTS</a>
                        <a className='btn btn-link' href='#' onClick={handleShowHideSerologyTests}><span className='text'>SEROLOGY TESTS</span></a>
                    </div>
                </div>
            </div>
        </TopButtonsWrapper>
    );
}

export default TopButtons;